<script lang="ts">
  import * as Popover from "$lib/components/ui/popover";
  import { Button } from "@/lib/components/ui/button";

  export let title: string;
  export let onConfirm: () => void;
  let open = false;

</script>

<Popover.Root portal="#shadcn-ui-dialog-target" bind:open={open}>
  <Popover.Trigger asChild let:builder>
    <slot {builder}/>
  </Popover.Trigger>
  <Popover.Content side='top' class="w-[200px] min-w-0">
    <div class='flex flex-col w-full gap-2 items-center'>
      <div class='font-semibold'>{title}</div>
      <div class='flex flex-row gap-2 w-full'>
        <Button variant='outline' size='sm' class='flex-1' on:click={() => open = false}>
          Cancel
        </Button>
        <Button size='sm' class='flex-1' on:click={() => {onConfirm(); open = false}}>
          Confirm
        </Button>
      </div>
    </div>
  </Popover.Content>
</Popover.Root>